import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AdminHolidaysModal from './AdminHolidaysModal';
import { ADMIN_GROUP } from '../../../Utils/Constants';


const adminTableHeader = [
  { id: 'id', label: 'ID' },
  { id: 'description', label: 'DESCRITIVO' },
  { id: 'day', label: 'DIA' },
  { id: 'month', label: 'MÊS' },
  { id: 'year', label: 'ANO' },
  { id: 'active', label: 'ATIVO' }
];

const styles = ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  cellPaddingGeneral: {
    paddingLeft: '16px',
    '&:last-child': {
      paddingLeft: '16px'
    }
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class AdminHolidaysTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };


  render() {
    const { order, orderBy, classes } = this.props;
    const userRT = this.props.user.UserRoleType;

    return (
      <TableHead className={classes.tblHead} >
        <TableRow className={classes.headerHeight} >
          {adminTableHeader.map(column => {
            return (
              <TableCell
                key={column.id}
                padding='none'
                sortDirection={orderBy === column.id ? order : false}
                className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, userRT.indexOf(ADMIN_GROUP) < 0 ? classes.cellPaddingGeneral : classes.cellPadding)}
              >
                <TableSortLabel
                  className={classes.tblHeadT}
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                  classes={{ icon: classes.tblSort }}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            );
          }, this)}
          {userRT.indexOf(ADMIN_GROUP) < 0 ?
            null :
            <TableCell key={'icon'} padding='none' className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter)}>
              <AdminHolidaysModal newEditButton={true} reloadTable={this.props.reloadTable.bind(this)} />
            </TableCell>
          }
        </TableRow>
      </TableHead>
    );
  }
}

AdminHolidaysTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(AdminHolidaysTableHeader));


// WEBPACK FOOTER //
// ./src/components/Administration/AdminHolidays/AdminHolidaysTableHeader.js